import { render, staticRenderFns } from "./partdependencymanagement.vue?vue&type=template&id=2eebf88c&lang=pug"
import script from "./partdependencymanagement.vue?vue&type=script&lang=js"
export * from "./partdependencymanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports